import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import NavProfileMenu from "./navigation/NavMenuProfile";
import NavMenus from "./navigation/NavMenus";
import { Link } from "react-router-dom";
import { StickyHeader, Header } from "@cxagroup/casper";
import LanguageSelector from "./LanguageSelector";
import CSSTransition from "react-transition-group/CSSTransition";
import { RouteMap } from "./navigation/routeMap";
import { loadNavigationMenu } from "actions/commonActions";
import { getHelpConfig } from "../../actions/needhelpActions";
import { setLanguageById } from "actions/localizationActions";
import Footer from "components/common/Footer";
import HRImpersonateMessageCard from "../hrAdmin/HRImpersonateMessageCard";
import { injectIntl } from "react-intl";
import SecondaryNav, { getCurrentTopNav } from "components/common/navigation/SecondaryNav";
import LogoPP from "./LogoPP";
import GlobalMessageBoard from "./global-message-board";
class Home extends React.Component {
  state = {
    headerState: {
      headerHeight: 0,
      pinned: null,
    },
  };

  getChildContext = () => {
    return {
      headerState: this.state.headerState,
    };
  };

  setHeaderState = (height, pinned) => {
    this.setState({
      headerState: {
        headerHeight: height,
        pinned: pinned,
      },
    });
  };

  loadMenu(props = this.props) {
    const { user, isAuthenticated, loadNavigationMenu, getHelpConfig,isFetching: ismenuFetching } = props;
    if (
      isAuthenticated &&
      !ismenuFetching &&
      user.pendingAuthActions &&
      user.pendingAuthActions.length === 0
    ) {
      loadNavigationMenu();
      getHelpConfig();
    }
  }

  onLanSelected = id => {
    const { setLanguageById } = this.props;

    setLanguageById(id);
  };

  componentDidMount() {
    this.loadMenu(this.props);
  }

  // Determines if the current menu has a sub menu
  currentMenuHasChildren(menuItems, path) {
    const currentTopNav = getCurrentTopNav(path, menuItems);

    return !!currentTopNav && !!currentTopNav.children && currentTopNav.children.length > 0;
  }

  render() {
    const {
      children,
      user,
      isAuthenticated,
      error,
      menuItems,
      profileMenu,
      client,
      push,
      languages,
      selectedLanguage,
      logoUrl,
      faqLabel,
      faqUrl,
      localization,
    } = this.props;

    if (!(isAuthenticated && user.pendingAuthActions && user.pendingAuthActions.length === 0)) {
      return children;
    }
    if (!menuItems) {
      return null;
    }

    const hasSecondaryMenu =
      !!isAuthenticated &&
      this.currentMenuHasChildren(menuItems, this.context.router.route.location.pathname);

    const isHrAdmin = user && user.hrAdmin;
    const administeredEmployee =
      user && user.hrAdmin && user.employee ? user.employee.fullName : null;

    const isImpersonateEmployee =
      isAuthenticated && (isHrAdmin || administeredEmployee) && (user.employee && user.hrAdmin);

    let headerClass = `${
      languages.all.length && languages.all.length > 1 ? "apl-header__wrapper--has-language" : ""
    }`;

    const isHeaderFooterHiddenHRAdminContact =
      isHrAdmin && !isImpersonateEmployee && location.pathname === RouteMap.Contact;

    if (isImpersonateEmployee) {
      headerClass = `apl-header__wrapper--push ${headerClass}`;
    }

    return (
      <div className="cxa-wrapper">
        {isImpersonateEmployee ? <HRImpersonateMessageCard {...user} /> : <GlobalMessageBoard />}
        {!isHeaderFooterHiddenHRAdminContact && (
          <StickyHeader setHeaderState={this.setHeaderState} hasSecondaryMenu={hasSecondaryMenu}>
            {logoUrl ? (
              <Header
                logoUrl={logoUrl}
                className={headerClass}
                renderLogo={logo => (
                  <Link aria-label="Homepage" to="/">
                    {logo}
                  </Link>
                )}
              >
                {!!isAuthenticated && <NavMenus parents={menuItems} />}
                <NavProfileMenu
                  user={user}
                  isAuthenticated={isAuthenticated}
                  error={error}
                  profileMenu={profileMenu}
                  menuItems={menuItems}
                  push={push}
                />
                <LanguageSelector
                  languages={languages.all}
                  selectedLanguage={selectedLanguage}
                  onSelection={this.onLanSelected}
                />
              </Header>
            ) : (
              <div className={`csp-header__wrapper ${headerClass}`}>
                <h1 className="csp-header__title">
                  <Link aria-label="Homepage" to="/">
                    <LogoPP />
                  </Link>
                </h1>
                {!!isAuthenticated && <NavMenus parents={menuItems} />}
                <NavProfileMenu
                  user={user}
                  isAuthenticated={isAuthenticated}
                  error={error}
                  profileMenu={profileMenu}
                  menuItems={menuItems}
                  push={push}
                />
                <LanguageSelector
                  languages={languages.all}
                  selectedLanguage={selectedLanguage}
                  onSelection={this.onLanSelected}
                />
              </div>
            )}

            {!!isAuthenticated && (
              <SecondaryNav items={menuItems} selectedLanguage={localization.selectedLanguage} />
            )}
          </StickyHeader>
        )}
        <main className="main">
          <div className="u-padding-vertical o-wrapper">
            <CSSTransition
              classNames="fade"
              timeout={{ enter: 1500, exit: 1500 }}
              component="div"
              className="main-content fade"
            >
              {children}
            </CSSTransition>
          </div>
        </main>
        {!isHeaderFooterHiddenHRAdminContact && (
          <Footer client={client} faqLabel={faqLabel} faqUrl={faqUrl} />
        )}
      </div>
    );
  }
}

Home.propTypes = {
  client: PropTypes.string,
  logoUrl: PropTypes.string,
  children: PropTypes.object,
  user: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  error: PropTypes.object,
  menuItems: PropTypes.array,
  profileMenu: PropTypes.object,
  languages: PropTypes.object,
  selectedLanguage: PropTypes.object,
  loadNavigationMenu: PropTypes.func,
  getHelpConfig: PropTypes.func,
  push: PropTypes.func,
  clientName: PropTypes.string,
  localization: PropTypes.object,
  setLanguageById: PropTypes.func,
  intl: PropTypes.object,
  faqLabel: PropTypes.string,
  faqUrl: PropTypes.string,
};

Home.childContextTypes = {
  headerState: PropTypes.object,
};

Home.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = ({ app, common, login, localization }) => ({
  ...common,
  client: app.client,
  clientName: app.clientName,
  user: login.user,
  isAuthenticated: login.isAuthenticated,
  error: login.error,
  languages: localization.languages,
  selectedLanguage: localization.selectedLanguage,
  localization,
});

const mapDispatchToProps = {
  loadNavigationMenu,
  setLanguageById,
  getHelpConfig,
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Home)
);



// WEBPACK FOOTER //
// ./components/common/Layout.jsx